import { type ReactElement } from 'react';
import Input from '@creditflowresearch/uilib/Input';
import Flex from '@creditflowresearch/uilib/Flex';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import useYield from './useYield';
import {
  FilterSectionIds,
} from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';

import styles from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/rangeFilter.module.scss';

const Yield = (): ReactElement => {
  const { minValue, maxValue, minMeta, maxMeta, handleMinChange, handleMaxChange } = useYield();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.Yield }
      header={ <FilterSectionHeader title="YIELD (%)" /> }
      dataTest="yieldSection"
    >
      <Flex align="center" gap={ 8 }>
        { /* @ts-ignore */ }
        <Input
          name="yieldMin"
          type="text"
          placeholder="Min"
          value={ minValue }
          onChange={ handleMinChange }
          meta={ minMeta }
          formFieldClassName={ styles.field }
          inputClassName={ styles.input }
          dataTest="filterMinInput"
          isNarrow
          isClearable={ false }
        />
        <span className={ styles.separator }>-</span>
        { /* @ts-ignore */ }
        <Input
          name="yieldMax"
          type="text"
          placeholder="Max"
          value={ maxValue }
          onChange={ handleMaxChange }
          meta={ maxMeta }
          formFieldClassName={ styles.field }
          inputClassName={ styles.input }
          dataTest="filterMaxInput"
          isNarrow
          isClearable={ false }
        />
      </Flex>
    </FilterSection>
  );
};

export default Yield;
